module.exports = __webpack_public_path__ + "img/new-sso-logo.05cd9551.svg";